import React, { useState, useEffect } from 'react';
import {
  TitleRow,
  ContainerRow,
  SearchInputStyle,
  ControlsDiV
} from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { useSelector } from 'react-redux';
import PageTitle from '../../../Utils/PageTitle';
import TanStackUserTable from '../../CustomComponents/TanStackUserTable';
import {
  RESULTS_PER_PAGE,
  SEARCH_DELAY
} from '../../../Constants/StringConstants';
import { getBillerAssignmentPicker } from '../../../Apis/Biller.js';
import { createDoctorColumns } from './tanstackColumnConfig';
import AddDoctorForm from './AddDoctorForm';
import CustomSideDrawer from '../../CustomComponents/CustomSideDrawer';
import { listAll, saveDoctor, editDoctor } from '../../../Apis/Doctor';
import { notification, Modal } from 'antd';
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import { useCallback } from 'react';
import { useDebounce } from '../../../Utils/Debounce';
import { AddButton } from '../styledComponents';
import { exportToExcel } from '../../../Utils/ExcelExport';
import InviteModal from '../../CustomComponents/InviteModal';
import { reInviteUser } from '../../../Apis/User';

import FacilityFilter from '../../CustomComponents/FacilityFilter';
import { getUserFacilities, getReviewers } from '../../../Apis/User.js';
import { disableOrEnableUser } from '../../../Apis/ClinicAdmin';

const Doctors = () => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const [searchString, setSearchString] = useState('');
  const [total, setTotal] = useState(0);
  const [reviewers, setReviewers] = useState([]);
  const [billersList, setBillersList] = useState([]);
  const [billerGroupsList, setBillerGroupsList] = useState([]);
  const [reviewersList, setReviewersList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [addDrawerVisible, setAddDrawerVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [filterKey, setFilterKey] = useState('name');
  const [sortOrder, setSortOrder] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [fetchAgain, setFetchAgain] = useState(false);

  const [facility, setFacility] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [clearFiltersTrigger, setClearFiltersTrigger] = useState(0);
  const userData = useSelector(state => state.userReducer);
  const notClinicAdmin =
    userData.userType !== 'clinicAdmin' && userData.userType !== 'admin';

  const billerConfigChanged = (oldConfig, newConfig) => {
    const sort = arr => [...(arr || [])].sort().join(',');
    return (
      sort(oldConfig?.billers) !== sort(newConfig?.billers) ||
      sort(oldConfig?.billerGroups) !== sort(newConfig?.billerGroups)
    );
  };

  const submitHandler = values => {
    // values.reviewerList = values.reviewerList.includes('none')
    //   ? []
    //   : values.reviewerList;

    const payload = values;
    values.phoneNumber.number = values.phoneNumber.number.replace(
      values.phoneNumber.countryCode,
      ''
    );
    if (selectedItem) {
      payload.id = selectedItem.id;

      const doSave = (updateBillerConfigForExistingJobs = false) => {
        setSubmitLoading(true);
        const params = updateBillerConfigForExistingJobs
          ? {
              updateBillerConfigForExistingJobs: true,
              sessionId: userData.sessionId
            }
          : {};
        editDoctor(payload, params)
          .then(response => {
            if (response.data.success) {
              notification['success']({
                message: 'Updated',
                description: 'Provider details updated.'
              });
              setSubmitLoading(false);
              setAddDrawerVisible(false);
              setSelectedItem(null);
              fetchAll();
            } else {
              notification['error']({
                message: 'Failed',
                description: response.data.message
              });
              setSubmitLoading(false);
            }
          })
          .catch(err => {
            setSubmitLoading(false);
            console.log(err);
          });
      };

      if (
        billerConfigChanged(selectedItem.billerConfig, payload.billerConfig)
      ) {
        Modal.confirm({
          title: 'Update existing jobs?',
          content: (
            <>
              <style>{`.biller-confirm-modal .ant-modal-content { border-radius: 8px; }`}</style>
              Do you want to assign all unbilled jobs to the new biller ?
            </>
          ),
          className: 'biller-confirm-modal',
          style: { top: 250 },
          okText: 'Yes',
          cancelText: 'No',
          okButtonProps: { style: { borderRadius: 8 } },
          cancelButtonProps: { style: { borderRadius: 8 } },
          onOk: () => doSave(true),
          onCancel: () => doSave(false)
        });
      } else {
        doSave(false);
      }
    } else {
      saveDoctor(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Added',
              description: 'Provider added successfully.'
            });
            setSubmitLoading(false);
            setAddDrawerVisible(false);
            setSelectedItem(null);
            fetchAll();
            setCurrentPage(0);
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    }
  };

  const reInvite = id => {
    reInviteUser(id)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const disableUser = id => {
    disableOrEnableUser(id)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
          fetchAll();
          setCurrentPage(0);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onChangeHandler = value => {
    setCurrentPage(0);
    setSearchString(value);
  };
  const debounceOnChange = useCallback(
    useDebounce(onChangeHandler, SEARCH_DELAY),
    []
  );

  const handleExport = () => {
    // Apply filters to data
    let filteredData = reviewers;

    // Apply facility filter
    if (facilities && facilities.length > 0) {
      filteredData = filteredData.filter(doctor =>
        doctor.facilities.some(facility =>
          facilities.includes(facility.facilityId)
        )
      );
    }

    // Apply search filter
    if (searchString) {
      const searchLower = searchString.toLowerCase();
      filteredData = filteredData.filter(doctor => {
        return (
          (doctor.fullName &&
            doctor.fullName.toLowerCase().includes(searchLower)) ||
          (doctor.email && doctor.email.toLowerCase().includes(searchLower)) ||
          (doctor.phoneNumber &&
            `${doctor.phoneNumber.countryCode}${doctor.phoneNumber.number}`.includes(
              searchLower
            ))
        );
      });
    }

    // Custom export columns
    const exportColumns = [
      { id: 'id', header: 'ID', accessorKey: 'id' },
      { id: 'fullName', header: 'Name', accessorKey: 'fullName' },
      { id: 'email', header: 'Email', accessorKey: 'email' },
      { id: 'phoneNumber', header: 'Phone Number', accessorKey: 'phoneNumber' },
      { id: 'facility', header: 'Facility', accessorKey: 'facilities' },
      {
        id: 'reviewerLevel',
        header: 'Reviewer Level',
        accessorKey: 'reviewerFlow'
      },
      {
        id: 'reviewersForLevel1',
        header: 'Reviewers',
        accessorKey: 'reviewerFlow'
      },
      {
        id: 'dictationType',
        header: 'Dictation Type',
        accessorKey: 'dictationType'
      },
      { id: 'biller', header: 'Biller', accessorKey: 'biller' },
      { id: 'billerGroup', header: 'Biller Group', accessorKey: 'billerGroup' },
      { id: 'createdAt', header: 'Created At', accessorKey: 'createdAt' }
    ];

    exportToExcel(filteredData, exportColumns, 'Doctors');
  };

  const filterTableChange = (pagination, filters, sorter) => {
    if (sorter.field !== undefined)
      setFilterKey(sorter.field && sorter.field[0]);
    if (sorter.order !== undefined) setSortOrder(sorter.order);
  };

  const fetchAll = () => {
    setLoading(true);
    // Simplified API call - backend sends all items without pagination params
    listAll()
      .then(response => {
        setLoading(false);
        setFetchAgain(false);
        if (response.data.success) {
          setTotal(response.data.size);
          setReviewers(response.data.result);
        }
      })
      .catch(() => {
        setLoading(false);
        setFetchAgain(false);
      });
    getBillerAssignmentPicker()
      .then(response => {
        if (response.data.success) {
          const result = response.data.result[0] || {};
          setBillersList(result.billers || []);
          setBillerGroupsList(result.billerGroups || []);
        }
      })
      .catch(() => {
        // Picker fetch error - don't affect main loading state
      });
    getReviewers()
      .then(response => {
        if (response.data.success) {
          setReviewersList(response.data.result);
        }
      })
      .catch(() => {
        // Reviewers fetch error - don't affect main loading state
      });
  };

  useEffect(() => {
    fetchAll();
    setCurrentPage(0);
    // eslint-disable-next-line
  }, []); // Fetch all data once on mount - filtering is done client-side

  useEffect(() => {
    if (fetchAgain && !modalVisible) {
      fetchAll();
      setCurrentPage(0);
    }
    // eslint-disable-next-line
  }, [modalVisible]);

  const getFacilities = () => {
    getUserFacilities()
      .then(response => {
        if (response.data.success) {
          setFacility(
            response.data.result.map(item => {
              return {
                label: item.facilityName,
                value: item.facilityId,
                disabled: item.disabled,
                className: item.disabled ? 'disabled-facility-option' : ''
              };
            })
          );
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    getFacilities();
  }, []);
  return (
    <>
      <PageTitle title='Doctors' />
      <ContainerRow gutter={[0, 40]}>
        <TitleRow justify='space-between'>
          <CustomTypography color={theme['@text-color']}>
            Providers
          </CustomTypography>
          <ControlsDiV>
            {/* <InviteButton
              icon={<MailOutlined />}
              shape='round'
              onClick={() => {
                setModalVisible(true);
              }}
            >
              Invite
            </InviteButton> */}
            <AddButton
              icon={<PlusOutlined />}
              type='primary'
              onClick={() => setAddDrawerVisible(true)}
            >
              Add
            </AddButton>
            <SearchInputStyle
              placeholder='Search'
              prefix={<SearchOutlined />}
              value={searchString}
              onChange={event => {
                setSearchString(event.target.value);
                debounceOnChange(event.target.value);
              }}
            />
            <AddButton icon={<DownloadOutlined />} onClick={handleExport}>
              Export to Excel
            </AddButton>
            <AddButton
              onClick={() => {
                setSearchString('');
                setClearFiltersTrigger(t => t + 1);
              }}
            >
              Clear Filter
            </AddButton>
            {/* <FacilityFilter setSelectedValues={setFacilities} /> */}
          </ControlsDiV>
        </TitleRow>
        <TanStackUserTable
          data={reviewers}
          columns={createDoctorColumns(
            setSelectedItem,
            setAddDrawerVisible,
            disableUser,
            reInvite,
            notClinicAdmin
          )}
          loading={loading}
          searchValue={searchString}
          storageKey='users_page_doctors'
          clearFiltersTrigger={clearFiltersTrigger}
          customFilterFn={
            facilities && facilities.length > 0
              ? doctor => {
                  // Filter by facility IDs if facilities are selected
                  return doctor.facilities.some(facility =>
                    facilities.includes(facility.facilityId)
                  );
                }
              : null
          }
        />

        <CustomSideDrawer
          title={selectedItem ? 'Edit Provider' : 'Add Provider'}
          placement='right'
          closable={false}
          onClose={() => {
            setSelectedItem(null);
            setAddDrawerVisible(false);
          }}
          visible={addDrawerVisible}
          width={400}
          destroyOnClose={true}
        >
          <AddDoctorForm
            facilities={facility}
            selectedItem={selectedItem}
            billersList={billersList}
            billerGroupsList={billerGroupsList}
            reviewerList={reviewersList}
            submitHandler={submitHandler}
            submitLoading={submitLoading}
          />
        </CustomSideDrawer>
      </ContainerRow>
      <InviteModal
        theme={theme}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        setFetchAgain={setFetchAgain}
      />
    </>
  );
};
export default Doctors;
